export default function Deal() {
  const cards = [
    {
      topic: "Better Brand Perception",
      content:
        "Consumers/ Shareholders are drawn to brands with values that align with their own.",
    },
    {
      topic: "Increase in Customer Lifetime Value",
      content:
        "Ethical companies create deeper, lasting connections with their customers.",
    },
    {
      topic: "Drive Positive Change",
      content: "Make a real-world difference while benefiting your business.",
    },
  ];

  return (
    <section className="p-20 md:px-40 bg-gray-100 text-center">
      <div className="max-w-5xl mx-auto">
        <h2 className="text-3xl font-bold text-left">
          A Deal That Works for You
        </h2>
        <p className="text-lg text-gray-700 mt-2 text-left">
          Joining the Founders Circle gives your brand a{" "}
          <span className="text-[#FF6700]"> competitive advantage</span> while
          making a{" "}
          <span className="text-[#FF6700]">positive social impact</span>
        </p>
        <div className="mt-6 grid grid-cols-1 md:grid-cols-3 gap-10">
          {cards.map((card, index) => (
            <div
              key={index}
              className="bg-white p-12 rounded-2xl shadow-md border border-[#004E98]"
            >
              <h3 className="text-xl font-semibold text-[#004E98]">
                {card.topic}
              </h3>
              <hr className="my-2 border-gray-300 w-1/3 mx-auto mt-6" />
              <p className="text-gray-600 mt-6">{card.content}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
